var _rect, _g, _g2, _g3, _g4, _rect2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48,
    fill: "#14213d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 32,
    height: 32,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 16,
    height: 16,
    fill: "#14213d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 8,
    width: 48,
    height: 48,
    fill: "#14213d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 16,
    width: 32,
    height: 32,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 24,
    width: 16,
    height: 16,
    fill: "#14213d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 144,
    width: 48,
    height: 48,
    fill: "#14213d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 152,
    width: 32,
    height: 32,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 160,
    width: 16,
    height: 16,
    fill: "#14213d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#14213d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 8,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 8,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 8,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 8,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 24,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 24,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 24,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 24,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 40,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 40,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 64,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 72,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 72,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 80,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 80,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 80,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 80,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 80,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 88,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 88,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 96,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 96,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 96,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 96,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 104,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 104,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 112,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 112,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 112,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 112,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 120,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 128,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 128,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 144,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 160,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 160,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 160,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 160,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 160,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 176,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 176,
    width: 8,
    height: 8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 86,
    width: 40,
    height: 28,
    rx: 4,
    fill: "#ffffff",
    stroke: "#14213d",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 105,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#14213d",
    textAnchor: "middle"
  }, "QR")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPlaceholder);
export default __webpack_public_path__ + "static/media/qr-placeholder.9589f85e4755804adfa3ea8f73e7dbe2.svg";
export { ForwardRef as ReactComponent };